import io from 'socket.io-client';
import { webURL } from './API';
import Cookies from "universal-cookie";

const cookies = new Cookies();
const socket = io(webURL, { auth: { token: cookies.get('token') }});
export default socket;